import { ComponentType, createContext, FC, useContext, useState } from 'react';
import noop from 'lodash/noop';
import { BookingDetailsPageContextValue } from './types';
import { useDetailsBooking } from '../../../lib/hooks';
import { showAdyenMigrationInfo } from '../helpers';

const BookingDetailsPageContext = createContext<BookingDetailsPageContextValue>({
  modals: {
    adyenMigrationActionableModal: {
      isActiveModal: false,
      isOpen: false,
      openModal: noop,
      closeModal: noop,
    },
  },
});

const BookingDetailsPageContextProvider: FC = ({ children }) => {
  const { booking } = useDetailsBooking();
  const [isAdyenMigrationActionableModalOpen, setAdyenMigrationActionableModalOpen] = useState(false);
  const isAdyenMigrationActionableModalActive = showAdyenMigrationInfo(booking);
  const openAdyenMigrationActionableModal = () => setAdyenMigrationActionableModalOpen(true);
  const closeAdyenMigrationActionableModal = () => setAdyenMigrationActionableModalOpen(false);

  const contextValue = {
    modals: {
      adyenMigrationActionableModal: {
        isActiveModal: isAdyenMigrationActionableModalActive,
        isOpen: isAdyenMigrationActionableModalOpen,
        openModal: openAdyenMigrationActionableModal,
        closeModal: closeAdyenMigrationActionableModal,
      },
    },
  };

  return <BookingDetailsPageContext.Provider value={contextValue}>{children}</BookingDetailsPageContext.Provider>;
};

// eslint-disable-next-line react/display-name
export const withBookingDetailsPageContext = (Component: ComponentType) => () => (
  <BookingDetailsPageContextProvider>
    <Component />
  </BookingDetailsPageContextProvider>
);

export const useBookingDetailsPageContext = () => useContext(BookingDetailsPageContext);
